<template>
  <!-- 特集 (Itinerary) / CMS タグ共通の行表示。
       Figma: row p-8 gap-8、サムネ 72x90、カテゴリラベル (bg-bg.inset / fg.accent 12/16 / px-4)、
       タイトル 16/24 fg.default ellipsis -->
  <NuxtLink class="flex items-center gap-2 rounded-[2px] p-2 hover:bg-black/5" :to="to" @click="onClick">
    <OptimizedImage loading="lazy" :alt="title" :class="['h-[90px] w-[72px] shrink-0 rounded-[2px] object-cover']" :image-url="thumbnailUrl" :optimized-image-options="{ width: 240 }" />
    <div class="flex min-w-0 flex-1 flex-col gap-1 font-Spectral">
      <span class="inline-flex w-fit items-center bg-beige1 px-1 text-[12px] leading-4 text-gold3">
        {{ categoryLabel }}
      </span>
      <p class="line-clamp-2 text-[16px] leading-6 text-gray4">{{ title }}</p>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import { OptimizedImage } from '@/wabunka-src/common/components';

// thumbnailUrl は CMS の生 URL（Algolia hit / getBackgroundImageUrl 由来）。最適化は OptimizedImage が行う。
defineProps<{
  to: string;
  thumbnailUrl: string;
  categoryLabel: string;
  title: string;
  onClick?: () => void;
}>();
</script>
